import { MutationTree } from 'vuex'
import { IAppointmentState } from '@/store/appointment'
import { Types, Store, Current, Query, Type, Open, ScrollTop } from '@/store/appointment/types'

const mutations: MutationTree<IAppointmentState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.query]: (state, action: Query) => {
    state.query = action.payload
  },
  [Types.type]: (state, action: Type) => {
    state.type = action.payload
  },
  [Types.open]: (state, action: Open) => {
    state.open = action.payload
  },
  [Types.scrollTop]: (state, action: ScrollTop) => {
    state.scrollTop = action.payload
  }
}

export default mutations
